import { useState, useRef } from "react";
import { UploadSimple, SpinnerGap, X } from "@phosphor-icons/react";
import { uploadFile, formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";

export default function ImageUpload({ value, onUploaded, label = "Image", className = "", testid = "image-upload" }) {
  const [busy, setBusy] = useState(false);
  const inputRef = useRef(null);

  const handle = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    try {
      const url = await uploadFile(file);
      onUploaded(url);
      toast.success(`${label} uploaded`);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Upload failed");
    } finally {
      setBusy(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  return (
    <div className={`flex items-center gap-3 ${className}`}>
      {value ? (
        <div className="relative">
          <img src={value} alt={label} className="h-16 w-16 rounded-xl border border-border object-cover" />
          <button type="button" onClick={() => onUploaded("")} className="absolute -right-2 -top-2 grid h-6 w-6 place-items-center rounded-full bg-primary text-primary-foreground" aria-label="Remove image"><X size={13} /></button>
        </div>
      ) : (
        <div className="grid h-16 w-16 place-items-center rounded-xl border border-dashed border-border text-muted-foreground"><UploadSimple size={22} /></div>
      )}
      <div>
        <button type="button" onClick={() => inputRef.current?.click()} disabled={busy} className="inline-flex items-center gap-2 rounded-full border border-border px-4 py-2 text-sm font-semibold hover:border-primary" data-testid={testid}>
          {busy ? <SpinnerGap size={16} className="animate-spin" /> : <UploadSimple size={16} />} {busy ? "Uploading…" : `Upload ${label}`}
        </button>
        <input ref={inputRef} type="file" accept="image/*" onChange={handle} className="hidden" />
      </div>
    </div>
  );
}
